module.exports = __webpack_public_path__ + "img/jinggaig.b4dbf811.png";